export const env = process.env.REACT_APP_API_HOST;
